var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-row",
    { attrs: { span: 24 } },
    [
      _c(
        "el-col",
        { attrs: { span: 12 } },
        [
          _c("app-display", {
            attrs: {
              label: "Área requerida:",
              content: _vm.cadastroOriginal.imovel.area || "-"
            }
          })
        ],
        1
      ),
      _c(
        "el-col",
        { attrs: { span: 12 } },
        [
          _c("app-display", {
            attrs: { label: "VTN:", content: _vm.formataVtn(_vm.vtn.vtn) }
          })
        ],
        1
      ),
      _c(
        "el-col",
        { attrs: { span: 12 } },
        [
          _c("app-display", {
            attrs: {
              label: "Valor de referência do imóvel:",
              content: _vm.formataVtn(_vm.vtn.valRefImovel)
            }
          })
        ],
        1
      ),
      _c(
        "el-col",
        { attrs: { span: 12 } },
        [
          _c("app-display", {
            attrs: {
              label: "Valor de referência por Ha:",
              content: _vm.formataVtn(_vm.vtn.valReHa)
            }
          })
        ],
        1
      ),
      _c(
        "el-col",
        { attrs: { span: 12 } },
        [
          _c("app-display", {
            attrs: {
              label: "Taxas diversas:",
              content: _vm.formataVtn(_vm.vtn.txdiversas)
            }
          })
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-1e069912", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1e069912","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/informacoesCadastro/InformacoesVtn.vue
// module id = null
// module chunks = 